export default __webpack_public_path__ + "static/media/pictureFolder.7fd8218c.svg";